import { useCallback } from 'react';

import { useTrackAssetModalThemeToggle } from '@air/analytics';

import { useAssetModalStore } from '~/components/v2/components/asset-modal/AssetModalStoreContext';
import { Theme } from '~/components/v2/store/shared/createThemeSlice';
import { disableAnimation } from '~/components/v2/utils/shared/disableAnimations';

type SelectableAssetModalTheme = Theme.Dark | Theme.Light;

export const useAssetModalThemeToggle = () => {
  const theme = useAssetModalStore((store) => store.theme);
  const setTheme = useAssetModalStore((store) => store.setTheme);
  const { trackAssetModalThemeToggle } = useTrackAssetModalThemeToggle();

  const themeLabel = theme === Theme.Dark ? 'Switch to light mode' : 'Switch to dark mode';

  const onSelectTheme = useCallback(
    (newTheme: SelectableAssetModalTheme) => {
      const enableAnimation = disableAnimation();

      setTheme(newTheme);
      trackAssetModalThemeToggle({ theme: newTheme });
      enableAnimation();
    },
    [setTheme, trackAssetModalThemeToggle],
  );

  const onToggleTheme = useCallback(() => {
    const newTheme = theme === Theme.Dark ? Theme.Light : Theme.Dark;
    onSelectTheme(newTheme);
  }, [onSelectTheme, theme]);

  return { onSelectTheme, onToggleTheme, theme, themeLabel };
};
